import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { USER} from "../../config/constants";
import socket, { APP_UPDATE_AVAILABLE } from "../../socket";
import { getFieldErrors, IFieldError} from "../helpers";
import { tryConfirmLogin } from "./authReducer";
import { IStaff } from "./staffsReducer";

export interface IRentalItemAttachment {
    _id: string;
    name: string;
    videoSrc: string;
    createdAt: string;
}

class RegRentalItemAttachmentErrs {
    index?: any;
    form: string | null = null;
    name: string | null = null;
    rentalItemAttachmentVideo: string | null = null;
}

export interface IRentalItemsAttachmentsState {
    registeredRentalItemAttachment: boolean;
    registeringRentalItemAttachment: boolean;
    regRentalItemAttachmentErrs: RegRentalItemAttachmentErrs;
    mainRentalItemAttachment: IRentalItemAttachment | null;
    updatingRentalItemAttachment: boolean;
    updatedRentalItemAttachment: boolean;
    updateRentalItemAttachmentErrs: RegRentalItemAttachmentErrs;
    deletingRentalItemAttachment: boolean;
    deletedRentalItemAttachment: boolean;
    deleteRentalItemAttachmentErr: string | null;
}

const initialState = {
    registeredRentalItemAttachment: false,
    registeringRentalItemAttachment: false,
    regRentalItemAttachmentErrs: new RegRentalItemAttachmentErrs(),
    mainRentalItemAttachment: null,
    updatingRentalItemAttachment: false,
    updatedRentalItemAttachment: false,
    updateRentalItemAttachmentErrs: new RegRentalItemAttachmentErrs(),
    deletingRentalItemAttachment: false,
    deletedRentalItemAttachment: false,
    deleteRentalItemAttachmentErr: null
} as IRentalItemsAttachmentsState

const rentalItemsAttachmentsSlice = createSlice({
    name: 'rentalItemsAttachmentss',
    initialState,
    reducers: {
        clearRegRentalItemAttachmentFieldErr: (state: IRentalItemsAttachmentsState, action: PayloadAction<string>) => {
            state.regRentalItemAttachmentErrs[action.payload as keyof RegRentalItemAttachmentErrs] = null;
        },
        clearRegRentalItemAttachmentErrs: (state: IRentalItemsAttachmentsState) => {
            state.regRentalItemAttachmentErrs = new RegRentalItemAttachmentErrs();
        },
        tryResetRegRentalItemAttachmentFormErr: (state: IRentalItemsAttachmentsState) => {
            let shouldReset = true;

            for (let key in state.regRentalItemAttachmentErrs) {

                if (key === 'form') {
                    continue;
                }

                if (state.regRentalItemAttachmentErrs[key as keyof RegRentalItemAttachmentErrs]) {
                    shouldReset = false;
                    break;
                }
            }

            if (shouldReset) {
                state.regRentalItemAttachmentErrs.form = null;
            }
        },
        resetRegisteredRentalItemAttachment: (state: IRentalItemsAttachmentsState) => {
            state.registeredRentalItemAttachment = false;
        },
        regRentalItemAttachmentStart: (state: IRentalItemsAttachmentsState) => {
            state.regRentalItemAttachmentErrs = new RegRentalItemAttachmentErrs();
            state.registeringRentalItemAttachment = true;
            state.registeredRentalItemAttachment = false;
        },
        regRentalItemAttachmentPass: (state: IRentalItemsAttachmentsState) => {
            state.registeringRentalItemAttachment = false;
            state.registeredRentalItemAttachment = true;
        },
        regRentalItemAttachmentFail: (state: IRentalItemsAttachmentsState, action: PayloadAction<IFieldError[]>) => {
            state.registeringRentalItemAttachment = false;

            const errs = action.payload;

            for (const err of errs) {
                for (const key in state.regRentalItemAttachmentErrs) {
                    if (err.field === key) {
                        state.regRentalItemAttachmentErrs[key as keyof RegRentalItemAttachmentErrs] = err.msg;
                        break;
                    }
                }
            }


            if (!state.regRentalItemAttachmentErrs.form) {
                state.regRentalItemAttachmentErrs.form = 'Form incorrectly filled.';
            }
        },
        setMainRentalAtachment: (state: IRentalItemsAttachmentsState, action: PayloadAction<IRentalItemAttachment | null>) => {
            state.mainRentalItemAttachment =  action.payload;
        },
        clearUpdateRentalItemAttachmentFieldErr: (state: IRentalItemsAttachmentsState, action: PayloadAction<string>) => {
            state.updateRentalItemAttachmentErrs[action.payload as keyof RegRentalItemAttachmentErrs] = null;
        },
        clearUpdateRentalItemAttachmentErrs: (state: IRentalItemsAttachmentsState) => {
            state.updateRentalItemAttachmentErrs = new RegRentalItemAttachmentErrs();
        },
        tryResetUpdateRentalItemAttachmentFormErr: (state: IRentalItemsAttachmentsState) => {
            let shouldReset = true;

            for (let key in state.updateRentalItemAttachmentErrs) {

                if (key === 'form') {
                    continue;
                }

                if (state.updateRentalItemAttachmentErrs[key as keyof RegRentalItemAttachmentErrs]) {
                    shouldReset = false;
                    break;
                }
            }

            if (shouldReset) {
                state.updateRentalItemAttachmentErrs.form = null;
            }
        },
        resetUpdatedRentalItemAttachment: (state: IRentalItemsAttachmentsState) => {
            state.updatedRentalItemAttachment = false;
        },
        updateRentalItemAttachmentStart: (state: IRentalItemsAttachmentsState) => {
            state.updateRentalItemAttachmentErrs = new RegRentalItemAttachmentErrs();
            state.updatedRentalItemAttachment = false;
            state.updatingRentalItemAttachment = true;
        },
        updateRentalItemAttachmentPass: (state: IRentalItemsAttachmentsState, action: PayloadAction<IRentalItemAttachment>) => {
            state.updatingRentalItemAttachment = false;
            state.updatedRentalItemAttachment = true;
            // state.mainCustomer = action.payload;
        },
        updateRentalItemAttachmentFail: (state: IRentalItemsAttachmentsState, action: PayloadAction<IFieldError[]>) => {
            state.updatingRentalItemAttachment = false;

            const errs = action.payload;

            for (const err of errs) {
                for (const key in state.updateRentalItemAttachmentErrs) {
                    if (err.field === key) {
                        state.updateRentalItemAttachmentErrs[key as keyof RegRentalItemAttachmentErrs] = err.msg;
                        break;
                    }
                }
            }


            if (!state.updateRentalItemAttachmentErrs.form) {
                state.updateRentalItemAttachmentErrs.form = 'Form incorrectly filled.';
            }
        },

        clearDeletRentalItemAttachmentErr: (state: IRentalItemsAttachmentsState) => {
            state.deleteRentalItemAttachmentErr = null;
        },
        resetDeletedRentalItemAttachment: (state: IRentalItemsAttachmentsState) => {
            state.deletedRentalItemAttachment = false;
        },
        deleteRentalItemAttachmentStart: (state: IRentalItemsAttachmentsState) => {
            state.deleteRentalItemAttachmentErr = null;
            state.deletedRentalItemAttachment = false;
            state.deletingRentalItemAttachment = true;
        },
        deleteRentalItemAttachmentPass: (state: IRentalItemsAttachmentsState) => {
            state.deletedRentalItemAttachment = true;
            state.deletingRentalItemAttachment = false;
        },
        deleteRentalItemAttachmentFail: (state: IRentalItemsAttachmentsState, action: PayloadAction<string>) => {
            state.deleteRentalItemAttachmentErr = action.payload;
            state.deletingRentalItemAttachment = false;
        }
    }
});

export const {
    clearRegRentalItemAttachmentFieldErr,
    clearRegRentalItemAttachmentErrs,
    tryResetRegRentalItemAttachmentFormErr,
    resetRegisteredRentalItemAttachment,
    regRentalItemAttachmentStart,
    regRentalItemAttachmentPass,
    regRentalItemAttachmentFail,
    setMainRentalAtachment,
    clearUpdateRentalItemAttachmentFieldErr,
    clearUpdateRentalItemAttachmentErrs,
    tryResetUpdateRentalItemAttachmentFormErr,
    resetUpdatedRentalItemAttachment,
    updateRentalItemAttachmentStart,
    updateRentalItemAttachmentPass,
    updateRentalItemAttachmentFail,
    clearDeletRentalItemAttachmentErr,
    resetDeletedRentalItemAttachment,
    deleteRentalItemAttachmentStart,
    deleteRentalItemAttachmentPass,
    deleteRentalItemAttachmentFail
} = rentalItemsAttachmentsSlice.actions;


interface ITryRegRentalItemAttachmentArg {
    formData: FormData;
    authToken: string;
}

export const tryRegRentalItemAttachment = createAsyncThunk('rentalItemsAttachments/tryRegRentalItemAttachment', (arg: ITryRegRentalItemAttachmentArg, { dispatch }) => {
    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/rental-item-attachment`;

    const { formData, authToken } = arg;

    dispatch(regRentalItemAttachmentStart());

    axios.post(endpoint, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        socket.emit(APP_UPDATE_AVAILABLE, USER);

        dispatch(regRentalItemAttachmentPass());
    }).catch(err => {

        const data = err?.response?.data;

        let fieldErrors: IFieldError[] = [];

        if (data?.errors) {
            fieldErrors = getFieldErrors(data.errors);
        } else if (data?.err) {
            fieldErrors = [{ field: 'form', msg: data.err }];
        } else {
            fieldErrors = [{ field: 'form', msg: 'Check your network connection.' }];
        }

        dispatch(regRentalItemAttachmentFail(fieldErrors));
    })
});

interface ITryUpdateRentalItemAttachmentArg {
    rentalItemAttachmentId: string;
    data: FormData;
    authToken: string;
}

export const tryUpdateRentalItemAttachment = createAsyncThunk('rentalItemsAttachments/tryUpdateRentalItemAttachment', (arg: ITryUpdateRentalItemAttachmentArg, { dispatch }) => {

    const { rentalItemAttachmentId, data, authToken,  } = arg;

    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/rental-items-attachments/${rentalItemAttachmentId}`;

    dispatch(updateRentalItemAttachmentStart());

    axios.put(endpoint, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        socket.emit(APP_UPDATE_AVAILABLE, USER);
        dispatch(updateRentalItemAttachmentPass(res.data));
    }).catch(err => {

        const data = err?.response?.data;

        let fieldErrors: IFieldError[] = [];

        if (data?.errors) {
            fieldErrors = getFieldErrors(data.errors);
        } else if (data?.err) {
            fieldErrors = [{ field: 'form', msg: data.err }];
        } else {
            fieldErrors = [{ field: 'form', msg: 'Check your network connection.' }];
        }

        dispatch(updateRentalItemAttachmentFail(fieldErrors));
    })
});


interface IDeleteRentalItemAttachmentArg {
    authToken: string;
    rentalItemAttachmentId: string;
}

export const tryDeleteRentalItemAttachment = createAsyncThunk('rentalItemsAttachments/deleteRentalItemAttachment', (arg: IDeleteRentalItemAttachmentArg, { dispatch }) => {
    const { authToken, rentalItemAttachmentId } = arg;

    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/rental-items-attachments/${rentalItemAttachmentId}`;

    dispatch(deleteRentalItemAttachmentStart())
    axios.delete(endpoint, {
        headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
        }
    }).then(res => {
        dispatch(deleteRentalItemAttachmentPass());
        socket.emit(APP_UPDATE_AVAILABLE, USER);
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({ authToken }));
            return;
        }
        let error = '';

        if (data?.err) {
            error = data.err;
        } else if (data?.errors) {
            error = getFieldErrors(data.errors)[0].msg;
        } else {
            error = 'Check your network connection.';
        }

        dispatch(deleteRentalItemAttachmentFail(error));
    });
});

export default rentalItemsAttachmentsSlice.reducer;
